module.exports = __webpack_public_path__ + "a0434b77936353e50dc6d0ec95346845.png";